import { tenant, forbidden, auth, common, menu, citySearch, validation, schedule, hr } from "./common";
import { ra } from "./ra";
import {
  user,
  role,
  company,
  jobApplication,
  jobApplicationSource,
  jobApplicationClosureReason,
  jobApplicationStatus,
  jobApplicationCalendar,
  jobApplicationDashboard,
  coursesManagement,
  myCourses,
  businessIntelligenceMarketAnalysis,
  businessIntelligenceSales,
  businessIntelligenceGeographicAnalysis,
  businessIntelligencePipelineAnalysis,
  businessIntelligenceIrt,
  conversation,
  conversations,
  tickets,
  ticket,
  contact,
  contactIdentity,
  channel,
  channelConnection,
  message,
  chat,
  email,
  ticketQueue,
  ticketQuickReply,
  internalChat,
  raFormLayout,
  tag,
  ticketTag,
  conversationTag,
  jobApplicationTag,
} from "./resources";

export const enMessages = {
  tenant,
  forbidden,
  auth,
  common,
  ra,
  resources: {
    users: "Users",
    groups: "Groups",
    user,
    role,
    company,
    "job-application": jobApplication,
    "job-application-source": jobApplicationSource,
    "job-application-closure-reason": jobApplicationClosureReason,
    "job-application-status": jobApplicationStatus,
    "job-application-calendar": jobApplicationCalendar,
    "job-application-dashboard": jobApplicationDashboard,
    "courses-management": coursesManagement,
    "my-courses": myCourses,
    "business-intelligence/market-analysis": businessIntelligenceMarketAnalysis,
    "business-intelligence/sales": businessIntelligenceSales,
    "business-intelligence/geographic-analysis": businessIntelligenceGeographicAnalysis,
    "business-intelligence/pipeline-analysis": businessIntelligencePipelineAnalysis,
    "business-intelligence/irt": businessIntelligenceIrt,
    conversation,
    conversations,
    tickets,
    ticket,
    contact,
    "contact-identity": contactIdentity,
    channel,
    "channel-connection": channelConnection,
    message,
    chat,
    email,
    "ticket-queue": ticketQueue,
    "ticket-quick-reply": ticketQuickReply,
    tag,
    "ticket-tag": ticketTag,
    "conversation-tag": conversationTag,
    "job-application-tag": jobApplicationTag,
    "internal-chat": internalChat,
  },
  hr,
  menu,
  citySearch,
  validation,
  "ra-form-layout": raFormLayout,
  schedule,
};
